import { gql } from '@/clients/utoniq-core'

export const fragments = {
  user: gql`
    fragment SignUpUser on User {
      id
      displayName
      avatar {
        uri
      }
      introduction
    }
  `,
  verifyCode: gql`
    fragment VerifyCode on EmailVerification {
      id
      verified
    }
  `,
  updateProfile: gql`
    fragment UserProfile on User {
      id
      accountId
      formattedAccountId @client
      displayName
      avatar {
        uri
        mediumUri
        smallUri
      }
      introduction
    }
  `,
} as const
